import React, { useEffect, useRef, useState } from "react";
import { Spin, message, Button } from "antd";
import { useNavigate } from "react-router-dom";
import SubscriptionPlans from "./SubscriptionPlans";
import SubscriptionInfo from "./SubscriptionInfo";
import VPNSection from "./VPNSection";
import ReferralBlockV2 from "./ReferralBlock_v2";
import FinanceAccessCard from "./FinanceAccessCard";
import SupportContacts from "../components/SupportContacts";
import { createPaymentAndRedirect, getSubscriptionStatus } from "../api_v2/subscription";
import { getToken } from "../api_v2/client";
import { useApp } from "../context/AppContext.tsx";
import "../SubscriptionPage.css";

function SubscriptionPage() {
  const { user, setUser, ready } = useApp();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [statusLoading, setStatusLoading] = useState(true);
  const paymentInFlight = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  useEffect(() => {
    if (!ready) return undefined;
    if (!getToken()) {
      message.warning("Пользователь не найден. Пожалуйста, зарегистрируйтесь.");
      navigate("/register");
      setStatusLoading(false);
      return undefined;
    }

    let cancelled = false;
    getSubscriptionStatus()
      .then((data) => {
        if (cancelled || !data?.success) return;
        setStatus(data);
        setUser({
          ...(user || {}),
          ...(data.user || {}),
          subscription: data.subscription || null,
          subscription_status: data.subscription_status,
        });
      })
      .catch((error) => {
        if (!cancelled && error?.response?.status !== 401) {
          message.error("Не удалось загрузить статус подписки");
        }
      })
      .finally(() => {
        if (!cancelled) setStatusLoading(false);
      });

    return () => {
      cancelled = true;
    };
    // Status is loaded once from the bearer session when the page opens.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, navigate]);

  const handleCreatePayment = async (plan) => {
    if (!plan?.id || paymentInFlight.current) return;
    paymentInFlight.current = true;
    setLoading(true);
    try {
      const result = await createPaymentAndRedirect(String(plan.id));
      if (!result.success) message.error(result.message);
    } catch {
      message.error("Ошибка создания платежа. Попробуйте снова.");
    } finally {
      paymentInFlight.current = false;
      setLoading(false);
    }
  };

  if (!ready || statusLoading) {
    return <Spin tip="Загрузка данных пользователя...">Загрузка...</Spin>;
  }

  const activeSubscription = status?.subscription_status === "active"
    ? status.subscription
    : null;

  const remainingTime = activeSubscription
    ? Math.ceil(
        (new Date(activeSubscription.end) - new Date()) /
          (1000 * 60 * 60 * 24)
      )
    : 0;

  return (
    <div className="subscription-page">
      {!activeSubscription && (
        <header className="subscription-simple-header">
          <h1>Выберите подписку</h1>
          <p>VPN и приложения Simol в одной подписке.</p>
        </header>
      )}

      {activeSubscription && (
        <section className="subscription-section">
          <header className="subscription-page__header">
            <div>
              <span className="subscription-page__eyebrow">SIMOL VIP</span>
              <h1>Ваша подписка</h1>
            </div>
          </header>
          <SubscriptionInfo
            endDate={activeSubscription.end}
            remainingDays={remainingTime}
          />
          <ReferralBlockV2 />
          <FinanceAccessCard />
          <VPNSection user={user} />
          <Button type="link" className="subscription-plan-link" onClick={() => navigate("/change-plan")}>
            Продлить или изменить подписку
          </Button>
        </section>
      )}

      {!activeSubscription && (
        <section className="subscription-section">
          <SubscriptionPlans
            onCreatePayment={handleCreatePayment}
            loading={loading}
          />
          <FinanceAccessCard />
        </section>
      )}

      <div className="subscription-footer">
        <SupportContacts />
      </div>

    </div>
  );
}

export default SubscriptionPage;
